import { useUserSession } from '@solinkcorp/authentication';
import CloudAiApi, { type FaceBlurQuotaData } from 'clients/CloudAiApi';
import useSWR, { type SWRResponse } from 'swr';

export type UseFaceBlurQuota = SWRResponse<FaceBlurQuotaData, Error>;

export default function useFaceBlurQuota(locationId: string): UseFaceBlurQuota {
  const userSession = useUserSession();

  const customerId = userSession.profile.customerId ?? '';

  // Create a unique key based on both customerId and locationId
  const cacheKey = customerId && locationId ? `face-blur-quota-${customerId}-${locationId}` : null;

  const faceblurQuota = useSWR<FaceBlurQuotaData>(cacheKey, () =>
    CloudAiApi.getFaceBlurringQuota(userSession.accessToken, customerId, locationId),
  );

  return faceblurQuota;
}
